import React from 'react';

const STROKE_LENGTH = 3000; // 房子轮廓路径的总长度
const ANIMATION_DURATION = 2000; // 动画持续时间（毫秒）
const COLOR = '#00c0b4'; // Grey color

interface Props {
  width?: number;
  height?: number;
}

export default function HomelinkLoadingSvg({
  width = 128,
  height = 93,
}: Props) {
  // 根据原始 SVG viewBox (0 0 1000 1000) 计算缩放
  const viewBox = '0 0 1000 1000';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width,
        height,
      }}
    >
      <svg width={width} height={height} viewBox={viewBox}>
        <style>
          {`
            @keyframes stroke-dash {
              from {
                stroke-dashoffset: ${STROKE_LENGTH};
              }
              to {
                stroke-dashoffset: 0;
              }
            }
            .animated-path {
              animation: stroke-dash ${ANIMATION_DURATION}ms linear infinite;
            }
          `}
        </style>
        <g>
          {/* HomeLINK 文字部分 - 静态 */}
          {/* "Home" 文字 */}
          <path
            fill={COLOR}
            d="M602.08,567.85v44.7h18.71v-54.67c0-10.36-1.77-16.68-5.92-21.14-4.39-4.55-11.22-7.06-19.2-7.06-11.89,0-22.72,8.8-27.92,16.77l-2.38-4.5c-4.42-8.37-11.15-12.27-21.18-12.27-12.35,0-20.85,5.45-27.62,19.2v-16.85h-17.98v80.51h18.7l.03-42.36c0-5.08.03-10.28,1.8-15.04,2.42-6.47,7.87-10.21,14.74-10.21,16.56,0,16.56,17.24,16.56,22.91v44.7h18.71v-44.7c0-5.67,0-22.91,16.56-22.91s16.38,17.24,16.38,22.91h0Z"
          />
          <path
            fill={COLOR}
            d="M437.25,529.67c-25.25,0-42.89,17.49-42.89,42.52s17.63,42.7,42.89,42.7,43.07-17.65,43.07-41.98c0-25.87-17.31-43.25-43.07-43.25h0ZM437.43,601.45c-15.37,0-24.18-10.66-24.18-29.25s8.75-29.07,24-29.07,24.18,10.52,24.18,29.61c0,17.98-8.97,28.71-24,28.71Z"
          />
          <polygon
            fill={COLOR}
            points="354.47 612.54 374.63 612.54 374.63 498.68 354.47 498.68 354.47 544.17 303.04 544.17 303.04 498.68 282.88 498.68 282.88 612.54 303.04 612.54 303.04 560.35 354.47 560.35 354.47 612.54"
          />
          {/* "Link" 文字 */}
          <polygon
            fill={COLOR}
            points="367.76 675.54 347.6 675.54 347.6 789.4 426.84 789.4 426.84 773.23 367.76 773.23 367.76 675.54"
          />
          <rect
            fill={COLOR}
            x={442.33}
            y={675.54}
            width={18.71}
            height={14.18}
          />
          <rect
            fill={COLOR}
            x={442.33}
            y={708.89}
            width={18.71}
            height={80.51}
          />
          <polygon
            fill={COLOR}
            points="654.42 708.89 632.58 708.89 600.67 740.58 600.67 675.54 581.96 675.54 581.96 789.4 600.67 789.4 600.67 762.25 613.29 749.91 638.89 789.4 659.23 789.4 625.03 738.27 654.42 708.89"
          />
          <path
            fill={COLOR}
            d="M530.62,706.35c-11.93,0-22.43,7.52-27.44,16.24v-13.7h-17.98v80.51h18.71v-45.6c0-8.63,1.18-12.88,4.69-16.83,3.35-3.8,8.22-5.9,13.69-5.9s10.62,2.42,13.44,6.64c2.85,4.28,3.31,8.67,3.31,17.54v44.15h18.71v-53.22c0-18.68-10.14-29.83-27.12-29.83h-.01Z"
          />
          <path
            fill={COLOR}
            d="M657.53,579.31c-.12-1-.2-2.01-.26-3.02h62.64c-.22-9.8-1.42-16.58-4.06-23.09-6-15.18-18.68-23.53-35.7-23.53-24.29,0-41.25,17.56-41.25,42.71s16.65,42.52,41.43,42.52c17.16,0,31.12-7.94,37.02-20.88h-19.23c-3.98,5.24-9.58,7.79-17.06,7.79-8.3,0-15.95-3.77-20.09-11.11-1.99-3.54-2.98-7.42-3.44-11.39h0ZM657.83,561.02c2.34-12.12,10.33-18.8,22.14-18.8s19.27,7.14,20.53,19.09l.41,3.88h-43.68l.61-4.18h-.01Z"
          />

          {/* 房子轮廓 - 描边动画部分 */}
          <path
            className="animated-path"
            d="M945.29,502.58l-221.89-188.87v-123.56c0-3.72-3.02-6.74-6.74-6.74h-72.99c-3.72,0-6.74,3.02-6.74,6.74v49.96l-127.95-108.91c-5.17-4.4-12.78-4.4-17.95,0L54.71,502.58c-9.57,8.44-3.6,24.23,9.16,24.23h91.65c7.65,0,13.85,6.2,13.85,13.85v317.6c0,7.65,6.2,13.85,13.85,13.85h633.57c7.65,0,13.85-6.2,13.85-13.85v-317.6c0-7.65,6.2-13.85,13.85-13.85h91.65c12.76,0,18.73-15.79,9.16-24.23h-.01Z"
            fill="none"
            stroke={COLOR}
            strokeWidth={30}
            strokeMiterlimit={10}
            strokeDasharray={STROKE_LENGTH}
          />
        </g>
      </svg>
    </div>
  );
}
